module.exports = __webpack_public_path__ + "images/little-tipper-7b57d91e1cd1a9c84c5d217ff98899d2.png";